var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { XRouterLink } from '../../ui';
import { util } from '../util';
export function Box(input) {
    var _a;
    var _b = input.padding, padding = _b === void 0 ? 0 : _b, _c = input.gap, gap = _c === void 0 ? 0 : _c, _d = input.round, round = _d === void 0 ? false : _d, _e = input.fullHeight, fullHeight = _e === void 0 ? false : _e, _f = input.fullWidth, fullWidth = _f === void 0 ? false : _f, _g = input.hidePrint, hidePrint = _g === void 0 ? false : _g, _h = input.flex, flex = _h === void 0 ? false : _h, _j = input.flexChildren, flexChildren = _j === void 0 ? false : _j, _k = input.align, align = _k === void 0 ? '' : _k, _l = input.justify, justify = _l === void 0 ? '' : _l, _m = input.direction, direction = _m === void 0 ? '' : _m, _o = input.grid, grid = _o === void 0 ? false : _o, colMaxSize = input.colMaxSize, stretch = input.stretch, _p = input.overflow, overflow = _p === void 0 ? '' : _p, _q = input.whiteSpace, whiteSpace = _q === void 0 ? '' : _q, className = input.className, as = input.as, rest = __rest(input, ["padding", "gap", "round", "fullHeight", "fullWidth", "hidePrint", "flex", "flexChildren", "align", "justify", "direction", "grid", "colMaxSize", "stretch", "overflow", "whiteSpace", "className", "as"]);
    var gridOptions = grid;
    var isStretch = stretch !== null && stretch !== void 0 ? stretch : (_a = grid) === null || _a === void 0 ? void 0 : _a.stretch;
    var isGrid = Boolean(grid || colMaxSize || isStretch);
    var min;
    var max;
    var minMaxClass = '';
    if (align || justify || flexChildren || direction) {
        flex = true;
        align = align || 'center';
    }
    var style = __assign({}, (rest.style || {}));
    if (isGrid) {
        var _min = colMaxSize !== null && colMaxSize !== void 0 ? colMaxSize : gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.min;
        if (_min) {
            min = util.isNumber(_min) ? _min + "px" : _min;
        }
        if (gridOptions === null || gridOptions === void 0 ? void 0 : gridOptions.max) {
            max = util.isNumber(gridOptions.max) ? gridOptions.max + "px" : gridOptions.max;
        }
    }
    if (min || max) {
        style.gridTemplateColumns = "repeat(auto-" + (isStretch ? 'fit' : 'fill') + ", minmax(" + (min || '1fr') + ", " + (max || '1fr') + "))";
        if (min) {
            minMaxClass += "min-" + min + " ";
        }
        if (max) {
            minMaxClass += "max-" + max + " ";
        }
    }
    var Component = rest.to ? XRouterLink : as || 'div';
    var _className = clsx(className, minMaxClass, "XR-Box p-" + (padding || '') + " g-" + gap + " ai-" + align + " jc-" + justify + " o-" + overflow + " ws-" + whiteSpace + " flex-" + (flex || '') + " fd-" + (direction || ''), {
        grid: isGrid,
        round: round,
        fullHeight: fullHeight,
        fullWidth: fullWidth,
        hidePrint: hidePrint,
        flex: flex,
        flexChildren: flexChildren,
    });
    return React.createElement(Component, __assign({ className: _className }, rest, { style: style }));
}
